import { render, staticRenderFns } from "./BasicCurrencyInput.vue?vue&type=template&id=ec8211f4&"
import script from "./BasicCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./BasicCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports